<template>
  <div class="project-configuration-container">
    <Section>
      <div class="section-body">
        <div class="project-configuration-detail">
          <p>ByteArk Lighthouse ซัพพอร์ตการทำงานกับ JWPlayer สามารถดูวิธีการติดตั้งได้จากข้างล่างนี้</p>
        </div>
        <div class="project-configuration-step">
          <div class="config-step-container">
            <label>1. ใส่แท็กโหลดสคริปท์ของ ByteArk Lighthouse คู่กับแท็กโหลดสคริปท์ของ JWPlayer</label>
            <div class="code-section">
              <CodeBlock :id="'step-1'" :code="projectCode(1)" :language="'html'" :readOnly="true">
                <button @click="doCopy('step-1')" class="btn btn-light btn-sm btn-copy">
                  <i class="fas fa-clipboard"></i>
                  {{state.isCopyBtnstep1isClicked ? 'Copied !' : 'Copy'}}
                </button>
              </CodeBlock>
            </div>
          </div>
          <div class="config-step-container">
            <label>
              2. เชื่อมกับตัวเล่นวิดีโอ JWPlayer ด้วยโค้ดด้านล่าง โดยระบุ
              <code>projectID</code> ในสคริปส์เซทอัพ ByteArk Lighthouse
            </label>
            <div class="code-section">
              <CodeBlock :id="'step-2'" :code="projectCode(2)" :language="'html'" :readOnly="true">
                <button @click="doCopy('step-2')" class="btn btn-light btn-sm btn-copy">
                  <i class="fas fa-clipboard"></i>
                  {{state.isCopyBtnstep2isClicked ? 'Copied !' : 'Copy'}}
                </button>
              </CodeBlock>
            </div>
          </div>
          <div class="config-step-container">
            <label>3. เสร็จเรียบร้อย!</label>
            <router-link :to="`/${teamName}/projects/${projectId}/summary`">
              ดูผลลัพธ์ในหน้า Summary
              <i class="fa fa-external-link-alt pl-1" />
            </router-link>
          </div>
        </div>
      </div>
    </Section>
  </div>
</template>

<script>
/* eslint-disable no-useless-escape */
import Section from '@/components/Section.vue';
import CodeBlock from '@/components/CodeBlock.vue';

export default {
  props: {
    project: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    Section,
    CodeBlock,
  },
  data() {
    return {
      state: {
        isCopyBtnstep1isClicked: false,
        isCopyBtnstep2isClicked: false,
      },
    };
  },
  computed: {
    teamName() {
      return this.$route.params.teamName;
    },
    projectId() {
      return this.$route.params.projectId;
    },
  },
  methods: {
    async doCopy(elementId) {
      if (elementId === 'step-1') {
        this.state.isCopyBtnstep1isClicked = true;
      } else {
        this.state.isCopyBtnstep2isClicked = true;
      }
      const copyText = document.getElementById(elementId).textContent;
      const textArea = document.createElement('textarea');
      textArea.value = copyText;
      textArea.style.position = 'fixed';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        setTimeout(() => {
          if (elementId === 'step-1') {
            this.state.isCopyBtnstep1isClicked = false;
          } else {
            this.state.isCopyBtnstep2isClicked = false;
          }
        }, 1000);
      } catch (err) {
        setTimeout(() => {
          if (elementId === 'step-1') {
            this.isCopyBtnstep1isClicked = false;
          } else {
            this.isCopyBtnstep2isClicked = false;
          }
        }, 1000);
      }

      document.body.removeChild(textArea);
    },
    projectCode(step) {
      if (step === 1) {
        return `<script type="text/javascript" src="https://byteark-sdk.cdn.byteark.com/lighthouse/jwplayer/@latest/lighthouse-jwplayer-plugin.js"><\/script>
<script type="text/javascript" src="https://content.jwplatform.com/libraries/AbnQ478C.js"><\/script>`;
      }
      return `<script>
      var player = jwplayer('video-player').setup({
        playlist: [
          {
            videoId: 'QObeO02cMYWl',
            title: 'BIG BUCK BUNNY',
            image: '//qoder.byteark.com/images/video-frames/1/GU/cg/1GUcghrocmlz-large.jpg',
            file: window.ByteArkLighthouse.createMediaUrl('//inox.qoder.byteark.com/video-objects/QObeO02cMYWl/playlist.m3u8'), // your media url
            onXhrOpen: function(xhr, url) {
              window.ByteArkLighthouse.injectXhr(xhr, url)
            }
          },
        ]
      })
      window.ByteArkLighthouse.init(player, {
        projectId: '${this.projectId}', // your project id
      })
<\/script>`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/page.scss';
@import '@/assets/scss/themes/components/list.scss';

.code-section {
  padding: $spacer;
  background-color: #2d2d2d;
  border-radius: $spacer * 0.25;
  color: $gray-200;
  position: relative;
}

.btn-copy {
  position: absolute;
  top: $spacer / 3;
  right: $spacer / 3;
}

.pre-section {
  // color: #e83e8c;
  color: $warning;
}

.project-configuration-detail {
  padding-bottom: $spacer * 1.25;
}

.config-step-container {
  padding-bottom: $spacer * 2;

  label {
    color: $gray-700;
  }
}
</style>
